import React from 'react';
import PropTypes from 'prop-types';
import { Radio, FormControlLabel } from '@material-ui/core';

const RadioButton = ({ value, label, children, classes, checkedIcon, ...props }) => {
  return (
    <FormControlLabel
      value={value}
      label={label || children}
      classes={{ label: classes.label, root: classes.labelRoot }}
      control={
        <Radio
          classes={{ root: classes.radioRoot }}
          icon={checkedIcon ? '' : <span className={classes.icon} />}
          checkedIcon={checkedIcon || <span className={classes.checkedIcon} />}
          color="default"
        />
      }
      {...props}
    />
  );
};

RadioButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.node,
  checkedIcon: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
};

RadioButton.defaultProps = {
  value: '',
  label: null,
  children: null,
  checkedIcon: null,
  classes: {},
};

export default RadioButton;
